import { observer } from 'mobx-react-lite';
import ElementResizer from './ElementResizer';
import type { ElementResizerProps } from './types';

export type { ElementResizerProps };
export default observer(ElementResizer);
